import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { List, ListItem, Text } from 'components/chroma';

const FreestandingHouseModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal header='When to answer "Yes"?' isOpen={isOpen} onClose={onClose}>
    <Text>Answer &ldquo;Yes&ldquo; if the gap:</Text>
    <List bullet>
      <ListItem key="partway">
        <Text>Only goes part way around the house; or</Text>
      </ListItem>
      <ListItem key="timberSlats">
        <Text>Is closed in by, timber slats</Text>
      </ListItem>
      <ListItem key="unsure">
        <Text>If you are still not sure, answer &ldquo;No&ldquo;</Text>
      </ListItem>
    </List>
  </Modal>
);

export default FreestandingHouseModal;
